import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Menu/menu.mjs';
import { css } from '@patternfly/react-styles';
export const MenuSearch = React.forwardRef((props, ref) => (React.createElement("div", Object.assign({}, props, { className: css(styles.menuSearch, props.className), ref: ref }))));
MenuSearch.displayName = 'MenuSearch';
//# sourceMappingURL=MenuSearch.js.map